import { Box, Flex } from '@chakra-ui/react';
import type { CSSProperties } from 'react';

interface SkeletonProps {
  width?: number | string;
  height?: number | string;
  borderRadius?: string;
  style?: CSSProperties;
}

export function Skeleton({
  width = '100%',
  height = 20,
  borderRadius = '6px',
  style,
}: SkeletonProps) {
  return (
    <div
      className="skeleton"
      style={{
        width: typeof width === 'number' ? `${width}px` : width,
        height: typeof height === 'number' ? `${height}px` : height,
        borderRadius,
        ...style,
      }}
    />
  );
}

export function SkeletonRows({ count = 5, height = 52 }: { count?: number; height?: number }) {
  return (
    <Flex direction="column" gap="1px">
      {Array.from({ length: count }, (_, i) => (
        <Flex
          key={i}
          align="center"
          gap="4"
          px="4"
          py="3"
          h={`${height}px`}
        >
          <Skeleton width={60} height={16} />
          <Skeleton width={120} height={16} />
          <Skeleton width={80} height={16} />
          <Skeleton width={64} height={16} />
          <Skeleton width={72} height={24} borderRadius="9999px" />
        </Flex>
      ))}
    </Flex>
  );
}
